/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetContextualSuggestedActionsRequest} from '@cash-web/protos/squareup/cash/cashfrontdoor/api/v1beta1/suggested_actions_messages.pb'
import {GetContextualSuggestedActionsResponse} from '@cash-web/protos/squareup/cash/cashfrontdoor/api/v1beta1/suggested_actions_messages.pb'


export const getContextualSuggestedActions = (request: GetContextualSuggestedActionsRequest, options?: CashRequestOptions) => post<GetContextualSuggestedActionsRequest, GetContextualSuggestedActionsResponse>("/2.0/cash/get-contextual-suggested-actions", request, {...options, rejectOnError: true })